<!-- HEADER -->
<header style="position: fixed; width: 100%; z-index: 9999;">
    <div>
        <div class="container" id="desktop-header">
            <div class="header-middle-container">
                <div class="header-middle-container-2" style="width: 20vw">
                    <a (click)="redirect('/')" style="cursor: pointer"><img src="assets/images/HITEC-logo.png"
                                                                            style="max-height: 80px"></a>
                </div>
                <nav>
                    <ul data-type="navbar" class="sf-menu">
                        <li class="header-link {{router.url === '/' ? 'active' : ''}}"><a (click)="redirect('')"
                        >{{"NAV.HOME" | translate }}</a>
                        </li>
                        <li class="header-link {{router.url === '/products' ? 'active' : ''}}"><a
                                (click)="redirect('/products')">{{"NAV.PRODUCTS" | translate }}</a>
                            <ul>
                                <li class="header-link"><a
                                        (click)="redirect('/products/excavators')">{{"NAV.KAIVURIT" | translate }}</a>
                                <li class="header-link"><a
                                        (click)="redirect('/products/mulchers')">{{"NAV.VESAKKOMURSKIMET" | translate }}</a>
                                </li>
                                <li class="header-link"><a
                                        (click)="redirect('/products/special')">{{"NAV.ERIKOISSOVELLUS" | translate }}</a>
                                </li>
                            </ul>
                        </li>
                        <li class="header-link {{router.url === '/services' ? 'active' : ''}}"><a
                                (click)="redirect('/services')">{{"NAV.SERVICES" | translate }}</a>
                        </li>
                        <li class="header-link {{router.url === '/about' ? 'active' : ''}}"><a
                                (click)="redirect('/about')">{{"NAV.ABOUT" | translate }}</a>
                        </li>
                        <li class="header-link {{router.url === '/location' ? 'active' : ''}}"><a
                                routerLink="/location">{{"NAV.LOCATION" | translate }}</a>
                        </li>
                        <li class="language-selector">
                            <select class="language-selector-dropdown"
                                    (change)="changeLanguage($event)"
                                    [ngModel]="selectedLanguage">
                                <option *ngFor="let language of languages"
                                        [value]="language.value">{{language.name}}</option>
                            </select>
                            <img style="margin-left: -20px; pointer-events:none;"
                                 src="assets/images/dropdownarrow.svg"/>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
    <app-mobile-sidebar class="mobile-bar-visibility"></app-mobile-sidebar>
</header>
<div style="height: 80px; width: 100%"></div>
<router-outlet></router-outlet>
<!-- FOOTER -->
<footer>
    <section class="well1 ins1 mobile-center">
        <div class="container">
            <div class="row">
                <div class="grid_3">
                    <div style="width: 100%">
                        <img src="assets/images/HITEC-logo.png" style="max-height: 60px; object-fit: contain;">
                        <br/>
                        <img src="assets/images/evetco-logo.png"
                             style="max-height: 60px; object-fit: contain;margin-top: 20px;">
                    </div>
                </div>
                <div class="grid_3">
                    <h5>{{"NAVIGATE" | translate}}</h5>
                    <nav>
                        <ul>
                            <li><a (click)="redirect('/home')">{{"NAV.HOME" | translate }}</a></li>
                            <li><a (click)="redirect('/products')">{{"NAV.PRODUCTS" | translate }}</a></li>
                            <li><a (click)="redirect('/services')">{{"NAV.SERVICES" | translate }}</a></li>
                            <li><a (click)="redirect('/about')">{{"NAV.ABOUT" | translate }}</a></li>
                            <li><a (click)="redirect('/location')">{{"NAV.LOCATION" | translate }}</a></li>
                        </ul>
                    </nav>
                </div>
                <div class="grid_3">
                    <h5>{{"CONTACT-INFO" | translate}}</h5>
                    <dl>
                        <a target="_blank"
                           href="https://www.google.com/maps/dir//61.1513486,21.55269/@61.151349,21.55269,14z">
                            <ul>
                                <li>Evetco Oy</li>
                                <li>Volttitie 18</li>
                                <li>26100 Rauma</li>
                            </ul>
                        </a>
                    </dl>
                    <br/>
                    <dl>
                        <dt>E-mail: &nbsp;</dt>
                        <dd><a href="mailto:#"> {{"SAHKOPOSTIMUOTO" | translate}}</a></dd>
                    </dl>
                    <br/>
                    <dl>
                        {{"CONTACTINFOFOUND" | translate}}
                    </dl>
                </div>
                <div class="grid_3">
                    <dl>
                        <h5>{{"BROCHURES" | translate}}</h5>
                        <a target="_blank" [href]="'BROCHURE-URL' | translate">{{"DOWNLOADBROCHURE" | translate}}</a>
                    </dl>
                    <br/>
                    <dl>
                        <dt></dt>
                        <dd><a href="https://www.youtube.com/channel/UCc8cDmOx1o_yBk2HovTRYqA" target="_blank"><img
                                alt="youtube" style="height: 35px;" src="/assets/icons/youtube.svg"/></a>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </section>
</footer>
